var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Quickbuy = (function (Quickbuy) {
        var QuickbuyList = {}

        Quickbuy.addToQuickbuyList = function (productsList, parse) {
            var color;
            for (var n = 0; n < productsList.length; n++) {    
                color = "";

                if (productsList[n].Color)
                    color = "-" + productsList[n].Color; 

                QuickbuyList[productsList[n].Id + color] = parse ? JSON.parse(productsList[n].Dimensionsjson) : productsList[n].Dimensionsjson;
            }
        };

        Quickbuy.Update = function ($wrapper, model) {
            var html = Vendd.Handlebars.parse("productDimensions", model);

            $wrapper.html(html);
        };

        Quickbuy.initState = function (productId, defaultColor) {
            var newState = {}, state;

            var customId = productId;
            if (defaultColor) {
                customId = productId + "-" + defaultColor;
            }

            state = GetDimJson(customId);

            if (state == null)
                return;

            newState.Colors = state.Colors;
            newState.Sizes = state.Sizes;
            newState.HasColors = state.SkuList.HasColors;
            newState.HasSizes = state.SkuList.HasSizes;
            newState.SelectColorText = state.SelectColorText;
            newState.SelectSizeText = state.SelectSizeText;
            newState.NoAvailableSizesText = state.NoAvailableSizesText;
            newState.HasSingleColor = (state.Colors.length == 1) ? true : false;
            newState.HasSingleSize = (state.Sizes.length == 1) ? true : false;
            newState.SizeDisabled = false;

            return newState;
        };

        Quickbuy.createNewState = function (wrapper, dimId, productId, defaultColor, type) {
            var availableDimList, state, json, skus;

            var customId = productId;
            if (defaultColor) {
                customId = productId + "-" + defaultColor;
            }

            json = GetDimJson(customId); 
            skus = json.SkuList.Skus;
            state = wrapper.model;

            if (type === 'color') {
                if (!state.HasSizes)
                    return;

                wrapper.SelectedColorId = dimId;
                availableDimList = _.first(_.filter(state.Colors, function (x) { return x.Id === dimId })).AvailableSizes;
                UpdateSelectedItems(state, dimId, true);

                state.Sizes = [];
                for (var i = 0; i < availableDimList.length; i++) {
                    var SizeArr = _.find(json.Sizes, function (x) { return x.Id === availableDimList[i] });
                    SizeArr.IsSelected = (typeof wrapper.SelectedSizeId != 'undefined' && wrapper.SelectedSizeId == availableDimList[i]) ? true : false;
                    state.Sizes[i] = SizeArr;
                }


                state.SizeDisabled = true;
                for (var i = 0; i < state.Sizes.length; i++) {
                    for (var j = 0; j < skus.length; j++) {
                        if (skus[j].ColorId == dimId && skus[j].SizeId == state.Sizes[i].Id) {
                            state.Sizes[i].Disabled = !skus[j].SkuData.CanBuy;

                            if (state.SizeDisabled && skus[j].SkuData.CanBuy) {
                                state.SizeDisabled = false;
                            }
                            break;
                        }
                    }
                }

            } else if (type === 'size') {

                if (!state.HasColors)
                    return;

                wrapper.SelectedSizeId = dimId;
                availableDimList = _.first(_.filter(state.Sizes, function (x) { return x.Id === dimId })).AvailableColors;
                UpdateSelectedItems(state, dimId, false);

                state.Colors = [];
                for (var i = 0; i < availableDimList.length; i++) {
                    var ColorArr = _.find(json.Colors, function (x) { return x.Id === availableDimList[i] });
                    ColorArr.IsSelected = (typeof wrapper.SelectedColorId != 'undefined' && wrapper.SelectedColorId == availableDimList[i]) ? true : false;
                    state.Colors[i] = ColorArr;
                }

                for (var i = 0; i < state.Colors.length; i++) {
                    for (var j = 0; j < skus.length; j++) {
                        if (skus[j].ColorId == state.Colors[i].Id && skus[j].SizeId == dimId) {
                            state.Colors[i].Disabled = !skus[j].SkuData.CanBuy;
                            break;
                        }
                    }
                }
            }
            return state;
        };

        Quickbuy.GetSkuData = function (productId, defaultColor, colorId, sizeid) {

            var customId = productId;
            if (defaultColor) {
                customId = productId + "-" + defaultColor;
            }

            var product = GetDimJson(customId);

            return (product == null) ? null : _.find(product.SkuList.Skus, function (x) { return x.ColorId === colorId && x.SizeId === sizeid });
        };

        var GetDimJson = function (productId) {
            return ($.isEmptyObject(QuickbuyList)) ? null : QuickbuyList[productId];
        };

        var UpdateSelectedItems = function (state, dimId, isColor) {
            var arr;

            if (isColor) {
                arr = state.Colors;
            } else {
                arr = state.Sizes;
            }

            for (var i = 0; i < arr.length; i++) {
                arr[i].IsSelected = false;

                if (arr[i].Id === dimId) {
                    arr[i].IsSelected = true;
                    if (isColor) {
                        state.SelectColorText = arr[i].Name;
                    } else {
                        state.SelectSizeText = arr[i].Name;
                    }
                }
            }
        };

        return Quickbuy;

    })(Vendd.Quickbuy || {});


    return Vendd;

})(Vendd || {});